"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const react_intl_1 = require("react-intl");
const react_router_dom_1 = require("react-router-dom");
const mui_page_layout_1 = require("@framework/mui-page-layout");
const LoginButtons = () => {
    const { formState: { isSubmitting }, } = (0, react_hook_form_1.useFormContext)();
    return ((0, jsx_runtime_1.jsxs)(mui_page_layout_1.ButtonToolbar, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, { variant: "text", type: "button", to: "/set-new-password", component: react_router_dom_1.Link, "data-testid": "SetNewPasswordButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.setNewPassword" }) }), (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", type: "submit", color: "primary", disabled: isSubmitting, "data-testid": "LoginButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.login" }) })] }));
};
exports.LoginButtons = LoginButtons;
//# sourceMappingURL=buttons.js.map